<script setup>
import { ref, onMounted } from 'vue'

const selectedConnection = ref(null)
const databases = ref([])
const tables = ref([])
const selectedDatabase = ref(null)
const selectedTable = ref(null)
const tableData = ref([])

const loadDatabases = async () => {
  if (!selectedConnection.value) return
  // Here you would make an API call to fetch databases
  databases.value = ['database1', 'database2'] // Example data
}

const loadTables = async () => {
  if (!selectedDatabase.value) return
  // Here you would make an API call to fetch tables
  tables.value = ['table1', 'table2'] // Example data
}

const loadTableData = async () => {
  if (!selectedTable.value) return
  // Here you would make an API call to fetch table data
  tableData.value = [
    { id: 1, name: 'Example' },
    { id: 2, name: 'Data' }
  ] // Example data
}

const createDatabase = async () => {
  // Implementation for creating new database
}

const createTable = async () => {
  // Implementation for creating new table
}
</script>

<template>
  <div class="space-y-6">
    <h2 class="text-2xl font-bold text-gray-800">MySQL Manager</h2>
    
    <!-- Connection Selector -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700">Select Connection</label>
      <select
        v-model="selectedConnection"
        @change="loadDatabases"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-pink-500 focus:ring-pink-500"
      >
        <option value="">Select a connection</option>
        <!-- You would populate this with actual connections -->
      </select>
    </div>

    <!-- Database Management -->
    <div v-if="selectedConnection" class="grid grid-cols-3 gap-6">
      <!-- Databases List -->
      <div class="border rounded-lg p-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="font-semibold">Databases</h3>
          <button
            @click="createDatabase"
            class="px-2 py-1 text-sm bg-pink-500 text-white rounded hover:bg-pink-600"
          >
            <i class="fas fa-plus mr-1"></i> New
          </button>
        </div>
        <div class="space-y-2">
          <button
            v-for="db in databases"
            :key="db"
            @click="selectedDatabase = db; loadTables()"
            class="block w-full text-left px-3 py-2 rounded hover:bg-gray-100"
            :class="{ 'bg-pink-50 text-pink-500': selectedDatabase === db }"
          >
            {{ db }}
          </button>
        </div>
      </div>

      <!-- Tables List -->
      <div v-if="selectedDatabase" class="border rounded-lg p-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="font-semibold">Tables</h3>
          <button
            @click="createTable"
            class="px-2 py-1 text-sm bg-pink-500 text-white rounded hover:bg-pink-600"
          >
            <i class="fas fa-plus mr-1"></i> New
          </button>
        </div>
        <div class="space-y-2">
          <button
            v-for="table in tables"
            :key="table"
            @click="selectedTable = table; loadTableData()"
            class="block w-full text-left px-3 py-2 rounded hover:bg-gray-100"
            :class="{ 'bg-pink-50 text-pink-500': selectedTable === table }"
          >
            {{ table }}
          </button>
        </div>
      </div>

      <!-- Table Data -->
      <div v-if="selectedTable" class="border rounded-lg p-4">
        <h3 class="font-semibold mb-4">Table Data</h3>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  v-for="(value, key) in tableData[0] || {}"
                  :key="key"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  {{ key }}
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="row in tableData" :key="row.id">
                <td
                  v-for="(value, key) in row"
                  :key="key"
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                >
                  {{ value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template> 